let _openModalFn: (() => void) | null = null;

export const getOpenModalFn = () => _openModalFn;

export const setOpenModalFn = (fn: (() => void) | null) => {
  _openModalFn = fn;
};
